module.exports = __webpack_public_path__ + "static/media/vegitables_8.c3601f83.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_8.csv
// module id = 668
// module chunks = 0